import React, { useEffect, useState } from "react";
import AndroidCabItem from "../SearchListItem";
import { getBookingFormatedValue } from "../../../utils/Functions";
import { useNavigate } from "react-router-dom";
import { useBoardingDropping } from "../../../context/BoardingDroppingContext";
import { getRidePostSearchRide } from "../../../utils/api.functions";
import Loader from "../../loader";
import { CITY_ID } from "../../../utils/common.data";
import "./style.css";

const SearchRideList = ({ handleView }) => {
  const [viewSeatId, setViewSeatId] = useState(null);
  const navigate = useNavigate();
  const [searchDetail, setSearchDetail] = useState({
    boarding: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [ridePost, setRidePost] = useState([]);
  const [view, setView] = useState(0);

  const {
    ridePostBoardingDroppingPoints,
    fetchRidePostBoardingDroppingPoints,
  } = useBoardingDropping();

  useEffect(() => {
    if (!ridePostBoardingDroppingPoints) {
      fetchRidePostBoardingDroppingPoints(); // Fetch data if not already available
    }
  }, [ridePostBoardingDroppingPoints, fetchRidePostBoardingDroppingPoints]);

  useEffect(() => {
    fetchRidePostBoardingDroppingPoints();
  }, []);

  useEffect(() => {
    const searchData = sessionStorage.getItem("searchdetails");
    if (searchData) {
      try {
        const searchValue = JSON.parse(searchData);
        setSearchDetail({
          ...searchDetail,
          ...searchValue,
        });
        fetchRidePosts(searchValue);
      } catch (error) {
        console.log(`search Data Err`, error);
      }
    }
  }, []);

  const handleRidePostData = (val, ridePost) => {
    if (ridePost) return val?.filter((value) => value.id == ridePost);
    return val.sort((a, b) => {
      return new Date(a.departure) - new Date(b.departure);
    });
  };

  const handleRidePostViewCab = (val, ridePost) => {
    return val?.filter((value) => value.id !== ridePost);
  };

  const handleCloseViewCab = () => {
    setViewSeatId(null);
  };

  const fetchRidePosts = async (value) => {
    const apiKey = sessionStorage.getItem("key");
    try {
      const response = await getRidePostSearchRide(
        { ...value, city_id: CITY_ID },
        apiKey
      );
      ////console.log({ response });

      if (response.status === 200) {
        const newData = response?.data?.resDecrypt?.response;

        // Check if the ridePost data already exists
        if (newData && newData.length > 0) {
          // Assuming the data has a unique identifier like id
          const newRidePostIds = newData.map((item) => item.id);

          setRidePost((prevRidePosts) => {
            // Filter out existing categories that already exist in newData
            const filteredPrevRidePosts = prevRidePosts?.filter(
              (item) => !newRidePostIds.includes(item.id)
            );

            // Merge the previous categories and new data
            const updatedRidePosts = [...filteredPrevRidePosts, ...newData];

            setIsLoading(false); // Disable loading once data is fetched
            return updatedRidePosts; // Return the merged data
          });
        } else {
          setIsLoading(false); // Disable loading if no data
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.log("ridePost Error", error);
      setIsLoading(false); // Disable loading in case of an error
    }
  };

  const handleViewChange = (val) => {
    if (handleView) {
      handleView();
      return;
    }
    ////setView(val)
    navigate("/booknow");
  };

  return (
    <div
      style={{ display: "inherit" }}
      className="android_booking_page_container main_booking_page_container st_slider_index_sidebar_main_wrapper st_slider_index_sidebar_main_wrapper_booking"
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            {view === 0 ? (
              <div className="search_data_main search_data_main_search_data">
                <div className="search_data_main_board">
                  {searchDetail?.boarding}
                </div>
                <div className="search_data_main_button">
                  <button
                    className="common_button_border"
                    type="button"
                    onClick={() => {
                      handleViewChange("/booknow");
                    }}
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      <div className="container search_main_new_booking_padding_container">
        <div className="row">
          {(isLoading || !isLoading) && (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              {isLoading && <Loader />}
              {!isLoading && ridePost && ridePost?.length == 0 && (
                <div className="no_data_found">
                  <h3>No Ride Found</h3>
                </div>
              )}
            </div>
          )}
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            {ridePost && ridePost?.length > 0 && (
              <div id="home" className="tab-pane active">
              <div style={{marginTop:'0.5rem'}} className="booking_card_item_list">
                {handleRidePostData(ridePost, viewSeatId).map(
                  (ridePostItem) => (
                    <AndroidCabItem
                      busValue={{
                        ...ridePostItem,
                      }}
                      key={ridePostItem?.id}
                      id={ridePostItem?.id}
                      name={`${ridePostItem?.from_location} - ${ridePostItem?.to_location}`}
                      departure={getBookingFormatedValue(
                        new Date(ridePostItem?.departure)
                      )}
                      seatsAvailable={ridePostItem?.seats}
                      fetchRidePosts={() => {
                        fetchRidePosts({
                          ride_id: ridePostItem?.id,
                        });
                      }}
                      viewSeatId={viewSeatId} // Pass the state
                      setViewSeatId={setViewSeatId} // Pass the setter
                      handleApiRedirect={handleView}
                    />
                  )
                )}
              </div>
            </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchRideList;
